import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { WorkAPI } from "../../../axios/api";
import { useAbortedEffect, useHookForm } from "../../../components/hooks";

import { FormCheckbox } from "../../../components/formElement/index";
import { formatResData, checkFormUpdate } from "../../../service/common";
import { option_category, option_enabled } from "../../../service/option";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function BackMemberSettingWork() {
  const route_params = useParams();
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const [reload, setReload] = useState({
    list: true,
  });
  const disabled = false;
  // 明細資料
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    target: [],
  };
  const { handleSubmit, reset, trigger, yup, setSchema, errors, setting } =
    useHookForm({
      defaultValues,
    });
  const dayArr = ["1", "2", "3", "4", "5", "6", "7"];

  useEffect(() => {
    setSchema(yup.object({}).required());
  }, []);

  useAbortedEffect(
    (signal) => {
      if (!reload.list || route_params.detailid === "add") {
        return;
      }

      dispatch(setProgress(true));

      let params = { memberid: route_params.detailid };

      WorkAPI.getPersonalGoalsDatasByMemberid({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          setApiData(data);

          let target = [];
          Object.values(data).forEach((item) => {
            if (!item) item = {};
            dayArr.forEach((day) => {
              if (item[`day${day}`] === 1) target.push(`${item.type}_${day}`);
            });
          });
          reset({ target });
          setReload((state) => ({ ...state, list: false }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    submitData = submitData.target.reduce((pre, cur) => {
      let [type, day] = cur.split("_");
      if (!pre[type]) pre[type] = [];
      pre[type].push(day);
      return pre;
    }, {});
    let jsonData = {
      memberid: Number(route_params.detailid),
      data: Object.entries(submitData).map(([type, days]) => {
        let temp = {
          type: Number(type),
          ...dayArr.reduce(
            (pre, cur) => ({
              ...pre,
              [`day${cur}`]: days.includes(cur) ? 1 : 0,
            }),
            {}
          ),
        };
        if (apiData[`type${type}`]?.id) temp.id = apiData[`type${type}`].id;

        return temp;
      }),
    };

    let promise;
    if (!apiData.type1) {
      // 新增
      promise = WorkAPI.setPersonalGoalsDatas({
        data: jsonData,
      });
    } else {
      // 修改
      promise = WorkAPI.updatePersonalGoalsDatas({
        data: jsonData,
      });
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `儲存成功`,
            detail: "",
          })
        );
        route_navigate("/back/member");
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `儲存失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <div className="border-round-lg bg-white p-3">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          <table className="w-full custom-tb text-center">
            <thead>
              <tr className="bg-blue-50">
                <th>項目</th>
                <th>週一</th>
                <th>週二</th>
                <th>週三</th>
                <th>週四</th>
                <th>週五</th>
                <th>週六</th>
                <th>週日</th>
              </tr>
            </thead>
            <tbody>
              {option_category.record.map((item) => (
                <tr key={`category_${item.value}`}>
                  <td className="bg-blue-50 py-2">{item.label}</td>
                  <td>
                    <FormCheckbox
                      className="flex justify-content-center m-0"
                      setting={setting}
                      data={{
                        name: "target",
                        label: "",
                        value: `${item.type}_1`,
                      }}
                    />
                  </td>
                  <td>
                    <FormCheckbox
                      className="flex justify-content-center m-0"
                      setting={setting}
                      data={{
                        name: "target",
                        label: "",
                        value: `${item.type}_2`,
                      }}
                    />
                  </td>
                  <td>
                    <FormCheckbox
                      className="flex justify-content-center m-0"
                      setting={setting}
                      data={{
                        name: "target",
                        label: "",
                        value: `${item.type}_3`,
                      }}
                    />
                  </td>
                  <td>
                    <FormCheckbox
                      className="flex justify-content-center m-0"
                      setting={setting}
                      data={{
                        name: "target",
                        label: "",
                        value: `${item.type}_4`,
                      }}
                    />
                  </td>
                  <td>
                    <FormCheckbox
                      className="flex justify-content-center m-0"
                      setting={setting}
                      data={{
                        name: "target",
                        label: "",
                        value: `${item.type}_5`,
                      }}
                    />
                  </td>
                  <td>
                    <FormCheckbox
                      className="flex justify-content-center m-0"
                      setting={setting}
                      data={{
                        name: "target",
                        label: "",
                        value: `${item.type}_6`,
                      }}
                    />
                  </td>
                  <td>
                    <FormCheckbox
                      className="flex justify-content-center m-0"
                      setting={setting}
                      data={{
                        name: "target",
                        label: "",
                        value: `${item.type}_7`,
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="field col-12 text-right mt-3 mb-0 px-0">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => route_navigate("/back/member")}
            />
            {!disabled && (
              <Button type="submit" label="儲存" className="ml-2 px-3" />
            )}
          </div>
        </form>
      </div>
    </>
  );
}
